import { SxProps, Theme } from '@mui/material/styles';

/** Vertical rhythm for parsed rich text blocks (theme spacing units). */
export const richTextBlockSpacingSx = (mb: number): SxProps<Theme> => ({
  mb,
  '&:last-child': { mb: 0 },
});

/** Bottom spacing for `body1` paragraphs in parsed rich text. */
export const richTextParagraphSpacingSx = richTextBlockSpacingSx(2);
